/* eslint-disable no-unused-vars */
import React from 'react'
import { Input, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { CustomCol, CustomTitle } from 'src/components'

interface ClimatetradeOffersFilterProps {
  filterText: string
  onChange: (value: string) => void
  length: number
}

const ClimatetradeOffersFilter: React.FC<ClimatetradeOffersFilterProps> = (props) => {
  const { t } = useTranslation()
  const { filterText, onChange, length } = props

  return <Row>
    <CustomCol lg={17}>
      <CustomTitle
        label={t('SalesOffer.CtOffersTitle', { length })}
        type={null}
      />
    </CustomCol>

    <CustomCol lg={7}>
      <Input
        value={filterText}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('Withdrawals.Filter')}
        prefix={<SearchOutlined />}
        allowClear
      />
    </CustomCol>
  </Row>
}

export default ClimatetradeOffersFilter
